import { BpTable } from '../../../../shared/components/cards/table/BpTable'
import { ColumnsType } from 'antd/lib/table'
import { useGetReferralStatByMonthQuery } from '../../../../app/api'
import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { useTranslation } from 'react-i18next'
import { selectReferrerProgramYear } from '../../model/referralProgramSlice'

export const ByMonthTable = () => {
  const { t } = useTranslation()
  const year = useAppSelector(selectReferrerProgramYear)

  const { data, isLoading, isFetching } = useGetReferralStatByMonthQuery(
    { year: Number(year) },
    { skip: !year },
  )

  const columns: ColumnsType<any> = [
    {
      title: t('table.columns.month'),
      dataIndex: 'month',
      key: 'month',
    },
    {
      title: t('table.columns.clicks'),
      dataIndex: 'clicks',
      key: 'clicks',
    },
    {
      title: t('table.columns.signups'),
      dataIndex: 'signups',
      key: 'signups',
    },
    {
      title: t('table.columns.paidReferrals'),
      dataIndex: 'paid_referrals',
      key: 'paid_referrals',
    },
    {
      title: t('table.columns.earned'),
      dataIndex: 'earned',
      key: 'earned',
    },
  ]

  return (
    <div>
      <BpTable
        columns={columns}
        dataSource={data?.data}
        hidePagination={true}
        loading={isLoading || isFetching}
        scroll={{ x: 420 }}
      />
    </div>
  )
}
